import type { FC } from "react";
import { MouseEvent } from "react";

import { t } from "i18n/i18n";
import { AddReferenceKeys } from "i18n/i18next";
import { SquareIconButton, SquareIconButtonSize } from "mds/components/buttons/SquareIconButton";
import { AddPlusIcon } from "mds/icons";

export interface AddIconButtonProps {
  className?: string;
  onClick: () => void;
  reference: AddReferenceKeys;
  eventPrefix?: string;
  size?: SquareIconButtonSize;
}

export const ToolbarAddIconButton: FC<AddIconButtonProps> = ({
  className,
  onClick,
  reference,
  eventPrefix,
  size = "s",
}) => {
  return (
    <SquareIconButton
      aria-label={t("edit_delete_widget.add", { context: reference })}
      className={className}
      eventName={eventPrefix ? `${eventPrefix}Add` : undefined}
      kind="ghost"
      size={size}
      onClick={(e: MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
    >
      <AddPlusIcon />
    </SquareIconButton>
  );
};
